import {
  RemixiconComponentType,
  RiBox3Line,
  RiProfileLine,
  RiSearchLine,
  RiUserSearchLine,
} from "@remixicon/react";

export interface PageIconNavsProps {
  id: any;
  icon: RemixiconComponentType;
  label: string;
  to: string;
}

export interface PageNavsProps {
  id: any;
  name: string;
  to: string;
}

export const myStoreNavsReseller: PageIconNavsProps[] = [
  {
    id: 1,
    icon: RiBox3Line,
    label: "Produk",
    to: "/reseller/mystore",
  },
  {
    id: 2,
    icon: RiProfileLine,
    label: "Profil Toko",
    to: "/reseller/mystore/profile",
  },
];

export const pickSupplierProduct: PageIconNavsProps[] = [
  {
    id: 1,
    icon: RiUserSearchLine,
    label: "Cari Supplier",
    to: "/reseller/search/supplier",
  },
  {
    id: 2,
    icon: RiSearchLine,
    label: "Cari Product",
    to: "/reseller/search/product",
  },
];

export const myStoreNavsSupplier: PageIconNavsProps[] = [
  {
    id: 1,
    icon: RiBox3Line,
    label: "Produk",
    to: "/supplier/mystore",
  },
  {
    id: 2,
    icon: RiProfileLine,
    label: "Profil Supplier",
    to: "/supplier/mystore/profile",
  },
];
